/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerFindAllQueryResponse, ApplicationsControllerFindAllQueryParams, ApplicationsControllerFindAll401, ApplicationsControllerFindAll403 } from "../../models/checklistsController/ApplicationsControllerFindAll";

function getApplicationsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-applications` as const }  
  return res
}

/**
 * @description Retrieve checklist applications with optional filtering by resource. Use `resourceId` and `resourceType` together to filter applications whose scope collection contains a scope that owns the specified resource (e.g., a specific File or Project). Example: `?resourceId=clh123&resourceType=FILE` returns applications applied to that file.
 * @summary Get all checklist applications
 * {@link /api/v1/checklist-applications}
 */
export async function applicationsControllerFindAll(params?: ApplicationsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationsControllerFindAllQueryResponse, ResponseErrorConfig<ApplicationsControllerFindAll401 | ApplicationsControllerFindAll403>, unknown>({ method : "GET", url : getApplicationsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}